import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useSetMainFilter } from '../../publicCatalogFiltersHooks';
import { useMenuStateContext } from './mobileCategoriesMenuStateContext';
import usageTracker from '../../../../utils/usageTracker';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MenuOptionButton = styled.div.withConfig({
  displayName: "MenuOption__MenuOptionButton",
  componentId: "sc-1cghqa8-0"
})(({
  theme: {
    color,
    space
  }
}) => ({
  span: {
    width: '100%',
    borderBottom: `1px solid ${color['border-core-subtle']}`,
    padding: `${space['300']} ${space['500']}`,
    display: 'flex',
    justifyContent: 'space-between'
  }
}));
const MenuOption = ({
  filterName,
  optionName,
  isSubMenu = false,
  isAllOption = false
}) => {
  const {
    openSubMenu,
    closeMenuModal
  } = useMenuStateContext();
  const setMainFilter = useSetMainFilter();
  const handleOptionClick = () => {
    setMainFilter(filterName, optionName);
    closeMenuModal();
  };
  const handleSubMenuOptionClick = () => {
    // @ts-expect-error if isSubMenu is true, optionName is a SubMenuName
    openSubMenu(optionName);
    usageTracker.track('interaction', {
      action: 'open-mobile-catalog-categories-submenu',
      value: optionName
    });
  };
  const allOptionPrefix = isAllOption ? 'ALL_' : '';
  return /*#__PURE__*/_jsx("div", {
    role: "menuitem",
    children: /*#__PURE__*/_jsx(MenuOptionButton, {
      $isSubMenu: isSubMenu,
      children: /*#__PURE__*/_jsxs(Button, {
        onClick: isSubMenu ? handleSubMenuOptionClick : handleOptionClick,
        use: "unstyled",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `academyPublic.catalogPage.filters.${filterName}.${allOptionPrefix}${optionName}`
        }), isSubMenu && /*#__PURE__*/_jsx(RightIcon, {
          color: "icon-tertiary-default",
          size: "300"
        })]
      })
    })
  });
};
export default MenuOption;